// this file added by Bearer Web Developer (InviteCodeState)
import { Instance, types } from "mobx-state-tree";
function getRandomInt(min: number = 1, max: number = 10) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
const inviteCodeValue = `Hey,

You should try Bearer — it’s the easiest way to send personal items in under 90 minutes. 🚀

Use my referral code {invite_code} at https://send.bearer.au to get started.

Enjoy using it to make your deliveries faster and easier, just like I do!`;
const randomShowingNumber = getRandomInt();
console.log("Random Number for Invite Code Showing: ", randomShowingNumber);
export const InviteCodeState = types
    .model("InviteCodeState", {
        open: types.optional(types.boolean, false),
        value: types.optional(types.string, ''),
        randomShowing: types.optional(types.number, randomShowingNumber),
    })
    .actions(self => {
        return {
            setOpen(value: boolean) {
                self.open = value;
            },
            setValue(value: string) {
                self.value = value;
            }
        }
    }).actions(self => {
        return {
            copyTextField: (copyTextValue: string | undefined) => {
                if (copyTextValue) {
                    // Copy the text
                    navigator.clipboard.writeText(copyTextValue);
                    // Alert the copied text
                    console.log("Copied the text: " + copyTextValue);
                }
            },
            shareTextField: async (shareText: string | undefined) => {
                if (navigator.share && shareText) {
                    try {
                        await navigator.share({
                            text: shareText
                        });
                        console.log("Sharing was successful");
                    } catch (err) {
                        console.log("User canceled sharing or an error occurred:", err);
                    }
                } else {
                    alert("Your browser does not support the Share feature");
                }
            },
            getInviteCodeValue: () => {
                return inviteCodeValue.replace("{invite_code}", self.value || "");
            }
        }
    })
export interface IInviteCodeState extends Instance<typeof InviteCodeState> { };